import { categories } from "@/mocks/categories";

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 rounded-full border border-background-300 text-sm font-medium text-foreground-600 bg-background-100">
            Product Categories
          </span>
          <h2 className="mt-4 text-2xl md:text-4xl font-bold text-foreground-900 font-heading leading-tight">
            Shop Every Category
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base">
            Browse through the complete acbuyspreadsheet product catalog
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 md:gap-4" data-product-shop>
          {categories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col rounded-xl bg-background-50 border border-background-200 hover:border-accent-300 overflow-hidden transition-all cursor-pointer"
            >
              <div className="w-full h-36 md:h-44 overflow-hidden bg-background-100">
                <img
                  src={cat.imageLarge}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="flex flex-col items-center gap-1.5 py-3 px-3">
                <span className="text-sm font-bold text-foreground-800 text-center leading-tight">
                  {cat.name}
                </span>
                <span className="text-xs text-accent-500 font-medium flex items-center gap-1 opacity-0 group-hover:opacity-100 transition-opacity">
                  Browse <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}